export default "__VITE_ASSET__COuurx5V__"